
import PlotModel from '../PlotModel';
import PropertyDescriptor from '../../../designer/utils/PropertyDescriptor';
import RectangleSettingsProperty from './RectangleSettingsProperty';

export default class Model extends PlotModel {

    settings = new PropertyDescriptor(new RectangleSettingsProperty(), "设置", "高级", "propertygrid", "#anticon-profile-setting", {
        gallery: "外观",
        valueTemplate: RectangleSettingsProperty,
    });

    constructor(opts = {}) {
        super();

        this.defineAllProperties();

        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    getType() {
        return "PlotRectangleModel";
    }

    toStyle() {
        return this.settings.toStyle();
    }
}
